import Color from "@arcgis/core/Color";

export type EsriLineStyles = "dash" | "dash-dot" | "dot" | "long-dash" | "long-dash-dot" | "long-dash-dot-dot"
| "none" | "short-dash" | "short-dash-dot" | "short-dash-dot-dot" | "short-dot" | "solid";

export type EsriFillStyle = "backward-diagonal" | "cross" | "diagonal-cross" | "forward-diagonal" | "horizontal" | "none" | "solid" | "vertical";

export type EsriColor = Color | number[] | string;

export class Colors {
    static readonly cyan = [
        51,
        255,
        254,
        1
    ];
    static readonly grey = [
        200,
        200,
        200,
        0.7
    ];
    static readonly red = [
        255,
        0,
        0,
        1
    ];
    static readonly darkgrey = [
        32,
        32,
        32,
        1
    ];
    static readonly transparent = [
        0,
        0,
        0,
        0
    ];
    static readonly black = [
        0,
        0,
        0
    ];
    static readonly white = [
        255,
        255,
        255
    ];
    static readonly selection = "yellow";
    static readonly selected = "cyan";
    static readonly selectedLight = [
        51,
        255,
        254,
        0.3
    ];
    static readonly positionPointer = "#C70B18";
    static readonly yellow = "#FFFF00";
    static readonly magenta = "#FD3DB5";
    static readonly darkyellow = "#888800";
    static readonly jordkabel = "#E64D00";
    static readonly vattendrag = "#006FFF";
    static readonly dike = "#006FFF";
    static readonly stup = "#FF00C5";
    static readonly stig = "#FF5500";
    static readonly skyddsdike = "#FF7F7F";
    static readonly yellow50p = [
        255,
        255,
        0,
        0.50
    ];
    static readonly magenta50p = [
        253,
        61,
        181,
        0.50
    ];
    static readonly cyan50p = [
        51,
        255,
        254,
        0.50
    ];
}
